// utils
import React, { useEffect } from "react";
import { useMatch } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../../utils/langUtils";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

//files
import square_black from "../../../../files/icons/rency/square_black.svg";

// sections
import MkitHero from "./components/m-kit-hero/m-kit-hero";
import MKitMoto from "./components/m-kit-moto/m-kit-moto";
import MKitContact from "./components/m-kit-contact/m-kit-contact";
import MKitMartin from "./components/m-kit-martin/m-kit-martin";
import MKitDocuments from "./components/m-kit-documents/m-kit-documents";



/**
 * MKIT page contains info about our M-KIT product
 * @returns MKIT page HTML
 */
export default function Index() {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";

    let translation = translation_cs;
    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    // solves broken layout of some pages in build
    const [hasMounted, setHasMounted] = React.useState(false);
    React.useEffect(() => {
      setHasMounted(true);
    }, []);
    if (!hasMounted) {
      return null;
    }
    
    return (
        <>
            <MkitHero></MkitHero>
            <MKitMoto></MKitMoto>
            <MKitMartin></MKitMartin>
            <MKitDocuments></MKitDocuments>
            <MKitContact></MKitContact>
        </>
    );
}
